export default "__VITE_ASSET__D4CUuTYf__"